<template>
    <div class="row">
        <div class="col-12" v-if="success">
            <div class="newsletter--thankyou text-center">
                <div class="big">Hvala za zaupanje.</div>
                Poslali smo vam e-mail s potrditveno povezavo.
            </div>
        </div>
        <div class="col-12 col-lg-5 col-xxl-4 offset-xxl-1" v-else>
            <div class="newsletter--cta">
                <div class="big">Najdite svoj manjkajoči košček,</div>
                prijavite se na naše e-novice.
            </div>
        </div>
        <div class="col-12 col-md-10 col-lg-5" v-if="!success">
            <div class="form-group">
                <input type="email" :class="['form-control form-control-lg',  {'is-invalid': form.errors.has('email')}]" v-model="form.email" placeholder="vaš e-mail ..." required>
                <div class="invalid-feedback d-block">
                    <template v-if="form.errors.has('email')">
                        {{ form.errors.get('email') }}
                    </template>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox inverse">
                    <label>
                        <input type="checkbox" name="tos" value="1" v-model="form.tos">
                        <span>
                            Strinjam se s
                            <a href="/stran/politika-zasebnosti" target="_blank">Politiko zasebnosti.</a>
                        </span>
                    </label>
                </div>
                <div class="invalid-feedback d-block">
                    <template v-if="form.errors.has('tos')">
                        {{ form.errors.get('tos') }}
                    </template>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-2 col-xxl-1 text-center" v-if="!success">
            <button class="btn btn-outline-primary btn-subscribe" @click.prevent="signup">
                <i :class="['icon-send', {loading}]"></i>
            </button>
        </div>
    </div>
</template>

<script>
import to from '@Utils/to'
import Request from '@Utils/request'

export default {
    data() {
        return {
            success: false,
            loading: false,
            form: new Request({
                tos: false,
                email: ''
            })
        }
    },

    methods: {
        async signup() {
            this.loading = true;
            let [err, response] = await to(this.form.post('newsletter'))
            this.success = response && response.success
            this.loading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    input[type="email"] {
        margin-bottom: 0;
    }

    .invalid-feedback {
        height: 20px;
        padding: 0 0 0 1rem;
        margin: 10px 0 10px;
        color: white;
    }

    .btn-subscribe {
        overflow: hidden;
    }

    .icon-send {
        text-indent: 0;
        transition: text-indent .3s ease;

        &.loading {
            text-indent: 60px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/Newsletter.vue